import styled from 'styled-components';
import { RichTextPartial } from '@storefront/lib-global/partials/richText';
import { maxWidthPartial, media, spacing } from '@storefront/lib-global/stylings';

export const ProductPageContent = styled.div`
  @media ${media.greaterThan('lg')} {
    display: flex;
    justify-content: center;
    ${maxWidthPartial({ withPaddingXL: true })}
    padding-block: 33px;

    @media ${media.greaterThan('lg')} {
      padding-block: 16px 33px;
    }
    position: relative;
  }
`;

export const ProductPageContainer = styled.div`
  @media ${media.greaterThan('lg')} {
    position: relative;
  }
`;

export const ProductWrapper = styled.section<{ $isZoomOverlayActive: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 10px ${spacing.S} 33px;
  position: relative;
  visibility: ${({ $isZoomOverlayActive }) => ($isZoomOverlayActive ? 'hidden' : 'initial')};

  > * {
    flex: 1;
  }

  @media ${media.greaterThan('lg')} {
    flex-direction: row;
    gap: 33px;
    justify-content: center;
    padding: unset;
    width: 100%;
  }
`;

export const MobileProductNameContainer = styled.div`
  margin: 10px ${spacing.S} 0;
`;

export const DesktopProductNameContainer = styled.div`
  display: none;

  @media ${media.greaterThan('lg')} {
    display: block;
  }
`;

export const MobileProductPriceContainer = styled.div`
  margin: 10px ${spacing.S} 0;
`;

export const DesktopProductPriceContainer = styled.div`
  @media ${media.greaterThan('lg')} {
    display: flex;
    flex-direction: column;
  }
`;

export const ProductInfoContainer = styled.div`
  height: 100%;
  margin-top: ${spacing.M};

  @media ${media.greaterThan('lg')} {
    margin-top: 0;
    max-width: 523px;
    position: relative;
  }
`;

export const ProductInfoStickyContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  position: relative;

  @media ${media.greaterThan('lg')} {
    height: fit-content;
    overflow: auto;
    overflow-x: hidden;
    position: sticky;
    top: 80px;
  }
`;

export const TextBlock = styled(RichTextPartial)``;

export const PDPAmpComponentsAndDescription = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;

  > * {
    margin: 0;
  }

  @media ${media.greaterThan('lg')} {
    margin-bottom: 38px;
  }
`;

export const BelowTheFold = styled.div<{ $isZoomActive: boolean }>`
  display: ${({ $isZoomActive }) => ($isZoomActive ? 'none' : 'block')};
`;

export const MobileFinalSaleContainer = styled.div`
  @media ${media.greaterThan('lg')} {
    display: none;
  }
`;

export const DesktopFinalSaleContainer = styled.div`
  display: none;
  @media ${media.greaterThan('lg')} {
    display: flex;
  }
`;

export const DeliveryAndKlarnaContainer = styled.div<{ $isCustomShippingAndReturnsVisible?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${spacing.M};

  > * {
    margin: 0;
  }

  &:last-of-type {
    margin-top: ${({ $isCustomShippingAndReturnsVisible }) => ($isCustomShippingAndReturnsVisible ? '16px' : '32px')};
  }

  @media ${media.greaterThan('lg')} {
    gap: 52px;

    &:last-of-type {
      margin-top: ${({ $isCustomShippingAndReturnsVisible }) => ($isCustomShippingAndReturnsVisible ? '16px' : '52px')};
    }
  }
`;
